import './styles/Footer.scss'
import {Link} from 'react-router-dom'
import Logo from '../images/Logo--menu.svg'

import {useEffect} from 'react'

import {IoLocationOutline} from "react-icons/io5";
import {IoLogoInstagram} from "react-icons/io5";
import {IoMailOutline} from "react-icons/io5";

function Map2GIS() {
    useEffect(() => {
        // Загружаем API 2ГИС
        const script = document.createElement("script");
        script.src = "https://maps.api.2gis.ru/2.0/loader.js?pkg=full";
        script.async = true;

        script.onload = () => {
            let checkDG = setInterval(() => {
                if (window.DG) {
                    clearInterval(checkDG); // Останавливаем проверку
                    initMap(); // Инициализируем карту
                }
            }, 1000); // Проверяем каждые 100 мс
        };

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const initMap = () => {
        const map = window.DG.map('map-container', {
            center: [43.230117, 76.887394], // Алматы
            zoom: 25
        });

        const myIcon = window.DG.icon({
            iconUrl: Logo, // Ссылка на иконку
            iconSize: [48, 48]
        });

        // Добавляем маркер
        window.DG.marker([43.230117, 76.887394], {icon: myIcon})
            .addTo(map)
            .bindPopup("Офис компании Кибернетика");

    };

    return (
        <div className="map-wrapper">
            <div id="map-container"></div>
        </div>
    );
}


function Footer() {
    return (
        <div className="footer-container" id={'footer'}>
            <div className={'footer-container__link-list'}>
                <Link to="#">
                    <img src={Logo} alt=""/>
                </Link>

                <Link to="/privacy-policy" className="main-text tp-underline">
                    Политика конфиденциальности
                </Link>
                <br/>

                <div className="footer-container__link-list">
                    <div className="footer-container__link-list">
                        <div className="main-text main-text--thin tp-bold">Контакты</div>

                        <a href="tel:+77051904229" className='main-text'>
                            +7 705 190 42 29 <span className="main-text--thin">- Литвинов Семён</span>
                        </a>
                        <a href="tel:+77017290551" className='main-text'>
                            +7 701 729 05 51 <span className="main-text--thin">- Лукин Сергей</span>
                        </a>
                        <a href="tel:+77718000768" className='main-text'>
                            +7 771 800 07 68 <span className="main-text--thin">- Отдел HR</span>
                        </a>
                        <a href="tel:+77718000771" className='main-text'>
                            +7 771 800 07 71 <span className="main-text--thin">- Бухгалтерия</span>
                        </a>
                    </div>
                </div>

                <br/>


                <div className={'footer-container__link-list'}>


                    <div className={'footer-container__location'}>
                        <IoLogoInstagram size={24} color={'#8000d4'}/>
                        <a href={'https://www.instagram.com/cybernetica.kz'}> Наш инстаграм</a>
                    </div>


                    <div className={'footer-container__location'}>
                        <IoMailOutline size={24} color={'#8000d4'}/>
                        <a href="mailto:webinfo@cybernetica.kz">Наша почта webinfo@cybernetica.kz </a>
                    </div>

                </div>
            </div>


            <Map2GIS/>

            <div className={'footer-container__location'}>
                <IoLocationOutline size={24} color={'#8000d4'}/>
                Республика Казахстан Г. Алматы ул. Егизбаева 13/54Б офис 309
            </div>
        </div>
    )
}

export default Footer
